import {
  SegmentTrackSchema,
  segmentTrackSchema,
} from '../../utils/validation-schemas/segment/track';

export const healthArticleHeroCTASegment = segmentTrackSchema.cast({
  event: 'Health CTA Clicked',
  properties: {
    name: 'hero',
  },
} as SegmentTrackSchema);

export const healthArticleBouncerCTASegment = segmentTrackSchema.cast({
  event: 'Health CTA Clicked',
  properties: {
    name: 'bouncer',
  },
} as SegmentTrackSchema);

export const healthArticleModalCTASegment = segmentTrackSchema.cast({
  event: 'Health CTA Clicked',
  properties: {
    name: 'modal',
  },
} as SegmentTrackSchema);

export const healthArticleArticleCostCTASegment = segmentTrackSchema.cast({
  event: 'Health CTA Clicked',
  properties: {
    name: 'article-cost',
  },
} as SegmentTrackSchema);
